module.exports = __webpack_public_path__ + "img/info.5cb1b113.svg";